import script from "./Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./Mobile.vue?vue&type=script&setup=true&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=3e04beaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e04beaf"]])

export default __exports__